import { useQuery } from "@tanstack/react-query";
import { fetchFromApi } from "api/apiClient";
import { FeatureFlagsResponse } from "types/featureFlagTypes";


// Base API URL

const REACT_APP_DARWIN_URL = process.env.REACT_APP_DARWIN_URL;


//Query Keys

const FEATURE_FLAGS_QUERY_KEY = 'feature_flags';

/**
 * get feature-flags
 */
export const useGetFeatureFlags = () => {
  return useQuery({
    queryKey: [FEATURE_FLAGS_QUERY_KEY],
    queryFn: () =>
      fetchFromApi<FeatureFlagsResponse>(
        `${REACT_APP_DARWIN_URL}/feature-flags`
      ),
    refetchOnWindowFocus: false
  });
};